
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqK14_45dLmq9LABxyEtaWSRtakwJDZXzgsU78GS_452snGLYMeta } from "/codebuild/output/src2605426181/src/src/pages/faq.vue?macro=true";
import { default as menucO5I5QVnBOUmi_45gn8eUaJCsmiWpRQmC8QzXv4FDTQVMMeta } from "/codebuild/output/src2605426181/src/src/pages/menu.vue?macro=true";
import { default as indexV7fSHoFqnb3FiLnyF53EzmalSfOGU4WQ7YTFLCZzQHAMeta } from "/codebuild/output/src2605426181/src/src/pages/index.vue?macro=true";
import { default as contactYsb0GqEMdCjJHtuSYYfXRKfEdxE1RVCQPfGHdLkhNEAMeta } from "/codebuild/output/src2605426181/src/src/pages/contact.vue?macro=true";
import { default as tutorialHrny0dNy2NSMBWodcdSU2S_k3WmLjepX0p5Vbdjje8IMeta } from "/codebuild/output/src2605426181/src/src/pages/tutorial.vue?macro=true";
import { default as agreementeQ0B2wyzdoccD1DcNCTeC3RVQmLo_LIwa9fSx4hh1U4Meta } from "/codebuild/output/src2605426181/src/src/pages/agreement.vue?macro=true";
import { default as about_45passK0N7gK9CY0fxJIP7iAtySpxLe3cSHPx7c_8wjSpOCjcMeta } from "/codebuild/output/src2605426181/src/src/pages/about-pass.vue?macro=true";
import { default as indexTJAvcP2lrAkjV940f0nsl2ngTVxXONuTPvXhONk9Kq4Meta } from "/codebuild/output/src2605426181/src/src/pages/card/index.vue?macro=true";
import { default as _91id_932v_vq8H2hebq4l7d0_6TI_3iHDkL94ndghaLahO3oNUMeta } from "/codebuild/output/src2605426181/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenance1UpPxWbC7wskdmpinq7wXOwl09xHx_Io9njEc28vtFQMeta } from "/codebuild/output/src2605426181/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93YBwOIIV9z6BCkCqfqgn5t7yzKoit16B__45TyUezoF_soMeta } from "/codebuild/output/src2605426181/src/src/pages/notice/[id].vue?macro=true";
import { default as indexMYdZ0RdbZCXj0s6LIjynRtQ0i4D4RXhdCSYzz3rudisMeta } from "/codebuild/output/src2605426181/src/src/pages/coupon/index.vue?macro=true";
import { default as indexOVHDeQs8f5KXBVi2wqSBe9pSunnqbGZYy5XbKZYdlG0Meta } from "/codebuild/output/src2605426181/src/src/pages/mypage/index.vue?macro=true";
import { default as indexqJ0L_XlkgOshmwegV_45dj7MXuEyhDi6MdMM003u_AIboMeta } from "/codebuild/output/src2605426181/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93dZPs2WhLgDWeLGfcJMjkUOGbYuQ9_eemsiHo7Fw4DZwMeta } from "/codebuild/output/src2605426181/src/src/pages/parking/[id].vue?macro=true";
import { default as index4HB9uNTvnPBJXeP7MNgfiSJE8qjHpUFdX4AEdmP2WSQMeta } from "/codebuild/output/src2605426181/src/src/pages/history/index.vue?macro=true";
import { default as indexZn0Iazmqi3aUF9qejGTWEt8vszdC18D_455cecGkcn3roMeta } from "/codebuild/output/src2605426181/src/src/pages/monthly/index.vue?macro=true";
import { default as indexLyOIHtFCAMXdPuPDwfWOhahLBkcFg2f6ehNjfwo5wWIMeta } from "/codebuild/output/src2605426181/src/src/pages/sign-in/index.vue?macro=true";
import { default as index6bbtug3bxvFWs3f_ihZ8GUYdrZuBFWCDCUc5IWJI6XsMeta } from "/codebuild/output/src2605426181/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviClkpqACka_45eD5DtfxZOw6GIwJzTTwHrHOMtM4OLVJukMeta } from "/codebuild/output/src2605426181/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editbjU1H__Q4xjZFDiUVwV5erY3ywt_45t_45Zb9V9h4tAdMPsMeta } from "/codebuild/output/src2605426181/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementR1omuCL6Wmk6bnRarH3UxOeFsUl_JolVErxIpzBspj8Meta } from "/codebuild/output/src2605426181/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexWsIbyb2_45oqoxg5jjtLCG0EgyBolfzQhkE0DLw7oqbL8Meta } from "/codebuild/output/src2605426181/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dYXSU_45mgvHTC40SD2R_45faW01KJuMh9BGJTOHc9w7e_45ucMeta } from "/codebuild/output/src2605426181/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirm5XC09zWnkQrC_45EGln7OUW6mrXkL0rHe9ln5N_21XbokMeta } from "/codebuild/output/src2605426181/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexntL4C4OEMKDOyiBhsEnPy7R4JtAYOUuhdTQGFuJV5mUMeta } from "/codebuild/output/src2605426181/src/src/pages/card/create/index.vue?macro=true";
import { default as indexsRHAAEKinVgvMNQMAgS7SvS6CHjdXXLDBIBjBQxNqt0Meta } from "/codebuild/output/src2605426181/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmm3Va9TDnLxCpC_kU8VpsOl4X2kP8IHjpx7qeCRagFVoMeta } from "/codebuild/output/src2605426181/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmIz9VaYAwzzGEqG0aR9hXPrsNobcJiui_Yv3lc6RGXJgMeta } from "/codebuild/output/src2605426181/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completem_45kwGvUO9bsmERYvew5Q4TDeX8LM3r4w4uHEkSa2x9MMeta } from "/codebuild/output/src2605426181/src/src/pages/membership/complete.vue?macro=true";
import { default as registeriFRovaS86L3ATSq_DTgVjNFtfrv769_452WpkiW4oRVXsMeta } from "/codebuild/output/src2605426181/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93TD0qA4tnMFy0KoRA2nmCCw_45hvKvDrVIpitTxRjGRQsMMeta } from "/codebuild/output/src2605426181/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmY7d5ntHG269i1X9oP3FPr0yhA6ptdtwQuGpI_45bZAjW0Meta } from "/codebuild/output/src2605426181/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93y9Cfh86EwLpgo_45Bg_45DybrWvccNjmMHFc5mwllZkMix8Meta } from "/codebuild/output/src2605426181/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexnAS_452NrHXyhjlDrqFCwQjGdq9MkxF1CV7GHEdwvGWOwMeta } from "/codebuild/output/src2605426181/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeSvMGQw__kKca7tjtQ2HMAzUbvUBTnxWpxg6HN8coVGkMeta } from "/codebuild/output/src2605426181/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45code9_45IneqIBBG_450Buhyr_dnijVyWO9bDoDZH_458WAPc7a68Meta } from "/codebuild/output/src2605426181/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeCeF8j00IPoa_45JCO0JL6eJVvWM_0L_4535E_45kgxxZVPuJwMeta } from "/codebuild/output/src2605426181/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerB7cDbfQ3hX_LYQd_Lox6tWuDlH9OGCO_45rZgioOeN3KYMeta } from "/codebuild/output/src2605426181/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeBXPokZfd3q6QqD_EuvnJ5pN5Vf7E9mIbVXcGDtMd6IsMeta } from "/codebuild/output/src2605426181/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexlSePhrMXAuG39OcjHGq2MC_459afmfRovEKzGptBllWRoMeta } from "/codebuild/output/src2605426181/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmz0htKoy4PVS0E83F_WQIEIyJ6XKfPzIfefNvq8aoqcsMeta } from "/codebuild/output/src2605426181/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completewBB9BoVqzRj_6j0jMpkgUxVGlvHfszsEphjF02M66gIMeta } from "/codebuild/output/src2605426181/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexVCGXD4WSABujbvJQhEoCn89dcAiZFpRBrkfY94hd5foMeta } from "/codebuild/output/src2605426181/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93T03fAe2hGsqCUla151_45_JB4VMSFu7QLqLrfGt3qfYUIMeta } from "/codebuild/output/src2605426181/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeQPnEEfGc9_xfD8wyedNcrU1_ZIIumzCfC_B2IH0ToykMeta } from "/codebuild/output/src2605426181/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasD4qNg2fZANmJbioy54z_452KIJGfEv5_45_convNJCIQrJwMeta } from "/codebuild/output/src2605426181/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleLR8XnbviIgiZb5N5f8_OF_Oj5KjFSa3g07WXBSd9rgQMeta } from "/codebuild/output/src2605426181/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45email67HYNZ09c5cqFSlfGCRG0895vunAuKJMb5b0_45knYMhkMeta } from "/codebuild/output/src2605426181/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirm7nPA7cnEh8tXTPvxvKkPtGM9ip6GeqH_bdJ0U3pMdfMMeta } from "/codebuild/output/src2605426181/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consent3XC_UdVebr6xEHEHv_K20WR8kL_45WNE4ZMi5lThEGlxIMeta } from "/codebuild/output/src2605426181/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirm5xZx4CS2IFwb9pGZ1hTPjuhNblTsLNbVbNyjHGhiG00Meta } from "/codebuild/output/src2605426181/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateUTx1FJjGOtvT8h6D_456mQvrPY2UYlBsfhrHiaJJ0_YCkMeta } from "/codebuild/output/src2605426181/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeVXB1D0fH1jm3Byz9c_5YrxQx7O7yLoNLJRlX0NCTt9MMeta } from "/codebuild/output/src2605426181/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codew1XpDTbWXf8jcb_45oKqPYjutIsDrlhmYglNjz271KiGwMeta } from "/codebuild/output/src2605426181/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordNvqheTurobP7zQHdcBxXhFdPUAKBCI8K7VV5m8xj6MYMeta } from "/codebuild/output/src2605426181/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasGX_B7swpGZ7dm6069nl5HJCyBN30pmGBVbfPP48fadoMeta } from "/codebuild/output/src2605426181/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerYKebS_zrhAi4kUPXxV3PzHVVFSJN2INdv2hC6BtyOvUMeta } from "/codebuild/output/src2605426181/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeWnlYyfqhfN1aC38A_TFtpMmKo7FAbCjkHr2OzR3lZMcMeta } from "/codebuild/output/src2605426181/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexHJ7vPM0sG7GyqYgDrSisBBtf3SGZjoxOX9pFpJoYcU8Meta } from "/codebuild/output/src2605426181/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexdV9aaoFxsKsDlW8uUg_45NA9Kbx57O5dChrW4aMp7SsfwMeta } from "/codebuild/output/src2605426181/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexzen_1O_45Yb51jLHU_Mwo6EplEwS3OC_45xR2kajNIVps9kMeta } from "/codebuild/output/src2605426181/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexGINI3zNfbSTBvbR8ZlyDP87I2183U1PAZT0IxBCmF9wMeta } from "/codebuild/output/src2605426181/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as update5s6MEf80huVdWlD_mNq0oMSDFQJKSo6JOuEMxsHU490Meta } from "/codebuild/output/src2605426181/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completek_45WBcot6U88pU7V1XXvc1q2hGDaI6r62_UYV9kEVH0AMeta } from "/codebuild/output/src2605426181/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmN9UWFk6Txo5oOAA5Txxqs_1_459_osWqeAvxsGj0ws0xgMeta } from "/codebuild/output/src2605426181/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexvlKHxUy_Z2T5_3AhvhqORF9eGK0AMMEpxVul_45lsffXsMeta } from "/codebuild/output/src2605426181/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeGMPSe1Xn4aimyfacinNAuXzsjWOkBdWVDbnGz4vqUAYMeta } from "/codebuild/output/src2605426181/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updater_45knsxEmcd11psgcSbVO8M8OD1U1MvT50eoDaPv_McQMeta } from "/codebuild/output/src2605426181/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexqsjhWzYsw7Is50IRyqfVvOXHJf8xKp5RwFBBDp_2xL0Meta } from "/codebuild/output/src2605426181/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexaDl_eDwbLyHmbfMC3I6HiiB_45GYEjiPpbKpl3Tfs_YZAMeta } from "/codebuild/output/src2605426181/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as complete68uHxVIBdgCNE9cEUni6tKvwqUzfatbuUaWUnhdIQv0Meta } from "/codebuild/output/src2605426181/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexJKKCR_Anpn06d0kirnCIeXeh_45h_45zhKzTJ5WCbiHCynYMeta } from "/codebuild/output/src2605426181/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codevIbAkrGIIrKQHIuRRLpPgAlPG14WkBo44ixpnBraTN4Meta } from "/codebuild/output/src2605426181/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexlUp2_lm87wgGfv7CxNllrHQd_Cx_i1JeiSF5r9k5YbQMeta } from "/codebuild/output/src2605426181/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexMZWh9Q1_452H73dbEJ5m9RgDCMDjlCxkOdHx7MlU0dy5cMeta } from "/codebuild/output/src2605426181/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexTZ_q3e5JDWad_jeAWgNn1PpKWXRlJBuOpbq1HINeK9MMeta } from "/codebuild/output/src2605426181/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as update5WjgZYaXDhp_aGbPL3H6zgccIf0dzK05_45y0VSB7gsUEMeta } from "/codebuild/output/src2605426181/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmXVONX_doUbhQPwIeDLjCXzIYXaHeUtzWJJVFDTS3SmQMeta } from "/codebuild/output/src2605426181/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menucO5I5QVnBOUmi_45gn8eUaJCsmiWpRQmC8QzXv4FDTQVMMeta || {},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexV7fSHoFqnb3FiLnyF53EzmalSfOGU4WQ7YTFLCZzQHAMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src2605426181/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexMYdZ0RdbZCXj0s6LIjynRtQ0i4D4RXhdCSYzz3rudisMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src2605426181/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index4HB9uNTvnPBJXeP7MNgfiSJE8qjHpUFdX4AEdmP2WSQMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src2605426181/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexLyOIHtFCAMXdPuPDwfWOhahLBkcFg2f6ehNjfwo5wWIMeta || {},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: index6bbtug3bxvFWs3f_ihZ8GUYdrZuBFWCDCUc5IWJI6XsMeta || {},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexntL4C4OEMKDOyiBhsEnPy7R4JtAYOUuhdTQGFuJV5mUMeta || {},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmm3Va9TDnLxCpC_kU8VpsOl4X2kP8IHjpx7qeCRagFVoMeta || {},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmIz9VaYAwzzGEqG0aR9hXPrsNobcJiui_Yv3lc6RGXJgMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src2605426181/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completem_45kwGvUO9bsmERYvew5Q4TDeX8LM3r4w4uHEkSa2x9MMeta || {},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registeriFRovaS86L3ATSq_DTgVjNFtfrv769_452WpkiW4oRVXsMeta || {},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmY7d5ntHG269i1X9oP3FPr0yhA6ptdtwQuGpI_45bZAjW0Meta || {},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeSvMGQw__kKca7tjtQ2HMAzUbvUBTnxWpxg6HN8coVGkMeta || {},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45code9_45IneqIBBG_450Buhyr_dnijVyWO9bDoDZH_458WAPc7a68Meta || {},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeCeF8j00IPoa_45JCO0JL6eJVvWM_0L_4535E_45kgxxZVPuJwMeta || {},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerB7cDbfQ3hX_LYQd_Lox6tWuDlH9OGCO_45rZgioOeN3KYMeta || {},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmz0htKoy4PVS0E83F_WQIEIyJ6XKfPzIfefNvq8aoqcsMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src2605426181/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completewBB9BoVqzRj_6j0jMpkgUxVGlvHfszsEphjF02M66gIMeta || {},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexVCGXD4WSABujbvJQhEoCn89dcAiZFpRBrkfY94hd5foMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2605426181/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeQPnEEfGc9_xfD8wyedNcrU1_ZIIumzCfC_B2IH0ToykMeta || {},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleLR8XnbviIgiZb5N5f8_OF_Oj5KjFSa3g07WXBSd9rgQMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src2605426181/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45email67HYNZ09c5cqFSlfGCRG0895vunAuKJMb5b0_45knYMhkMeta || {},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirm7nPA7cnEh8tXTPvxvKkPtGM9ip6GeqH_bdJ0U3pMdfMMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2605426181/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consent3XC_UdVebr6xEHEHv_K20WR8kL_45WNE4ZMi5lThEGlxIMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2605426181/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirm5xZx4CS2IFwb9pGZ1hTPjuhNblTsLNbVbNyjHGhiG00Meta || {},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeVXB1D0fH1jm3Byz9c_5YrxQx7O7yLoNLJRlX0NCTt9MMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src2605426181/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codew1XpDTbWXf8jcb_45oKqPYjutIsDrlhmYglNjz271KiGwMeta || {},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordNvqheTurobP7zQHdcBxXhFdPUAKBCI8K7VV5m8xj6MYMeta || {},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerYKebS_zrhAi4kUPXxV3PzHVVFSJN2INdv2hC6BtyOvUMeta || {},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeWnlYyfqhfN1aC38A_TFtpMmKo7FAbCjkHr2OzR3lZMcMeta || {},
    component: () => import("/codebuild/output/src2605426181/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src2605426181/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]